<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-header">
        <h2>灵易智模欢迎您</h2>
      </div>
      
      <div class="login-body">
        <div class="login-form">
          <div class="form-group">
            <label for="token">访问令牌</label>
            <input 
              type="text" 
              id="token" 
              v-model="token" 
              placeholder="请输入访问令牌"
              @keyup.enter="verifyAndLogin"
              ref="tokenInput"
            />
          </div>
          
          <!-- 错误信息显示 -->
          <div v-if="authError" class="auth-error">{{ authError }}</div>
          
          <!-- 登录按钮 -->
          <div class="form-actions">
            <button 
              class="login-button" 
              @click="verifyAndLogin()"
              :disabled="loggingIn || !token"
            >
              {{ loggingIn ? '登录中...' : '登录' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginPage',
  data() {
    return {
      token: '',
      loggingIn: false,
      authError: null
    }
  },
  mounted() {
    // 如果URL中包含错误信息参数，显示错误
    if (this.$route.query.error) {
      this.authError = this.$route.query.error;
    }
    
    // 自动聚焦到令牌输入框
    this.$nextTick(() => {
      this.$refs.tokenInput?.focus();
    });
  },
  methods: {
    // 验证令牌登录
    async verifyAndLogin() {
      if (this.loggingIn) return;
      
      if (!this.token.trim()) {
        this.authError = '令牌不能为空，请输入有效的访问令牌';
        this.$nextTick(() => {
          this.$refs.tokenInput?.focus();
        });
        return;
      }
      
      this.loggingIn = true;
      this.authError = null;
      
      // 使用API验证令牌
      const isValid = await this.verifyToken(this.token.trim());
      if (isValid) {
        // 登录成功
        localStorage.setItem('token', this.token);
        this.$emit('login-success', this.token);
        this.$router.push('/');
      } else {
        // 登录失败
        this.loggingIn = false;
        // 如果verifyToken中已设置错误信息，这里不重复设置
        if (!this.authError) {
          this.authError = '令牌验证失败，请检查后重试';
        }
      }
    },
    
    async verifyToken(token) {
      if (!token || token.trim() === '') {
        return false;
      }
      
      try {
        const response = await axios.get('/api/auth/verify', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        return response.data.code === 200;
      } catch (error) {
        console.error('令牌验证失败:', error);
        this.generateAuthErrorMessage(error);
        return false;
      }
    },
    
    generateAuthErrorMessage(error) {
      if (error.response) {
        if (error.response.status === 401) {
          this.authError = '令牌无效，请检查后重试';
        } else if (error.response.status === 403) {
          this.authError = '令牌权限不足，请联系管理员';
        } else {
          this.authError = `验证失败 (${error.response.status}): ${error.response.data?.message || '未知错误'}`;
        }
      } else if (error.request) {
        this.authError = '网络连接失败，请检查网络后重试';
      } else {
        this.authError = '验证过程中发生错误';
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.login-container {
  width: 380px;
  max-width: 90%;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.login-header {
  padding: 18px 20px;
  text-align: center;
  background-color: #f8fafc;
  border-bottom: 1px solid #ebeef5;
}

.login-header h2 {
  margin: 0;
  color: #303133;
  font-size: 20px;
  font-weight: 600;
}

.login-body {
  padding: 24px 20px;
}

.login-form {
  margin-bottom: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #606266;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-group input:focus {
  border-color: #409EFF;
  outline: none;
}

.auth-error {
  padding: 8px 12px;
  background-color: #fef0f0;
  color: #f56c6c;
  border-radius: 4px;
  font-size: 13px;
  margin-bottom: 20px;
}

.form-actions {
  display: flex;
  justify-content: center;
}

.login-button {
  width: 100%;
  padding: 12px 20px;
  background-color: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover {
  background-color: #66b1ff;
}

.login-button:disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .login-container {
    width: 90%;
  }
  
  .login-body {
    padding: 15px;
  }
}
</style> 